import MojitoCore from 'mojito/core';
import MojitoServices from 'mojito/services';

import {wrapExternal} from '../utils.js';

import {actions as BalancesActions, selectBalancesForHost} from './slice.js';
import {SPORTS_BONUS, SPORTS_TOKEN, WITHDRAWABLE} from './utils.js';
import {updateBalancesInMojFormat} from './pending-balances.js';

const {types: UserInfoTypes} = MojitoServices.UserInfo;
const reduxInstance = MojitoCore.Services.redux;
//------------------------------------------------------------------------------

// Put balances into UserInfo store (or pending), balances has the same format as SportsbookAPIBalancesStore.getBalances
export function updateBalances(APIBalances) {
    const result = Object.create(null);

    (APIBalances || []).forEach(balance => {
        switch (balance.balanceType) {
            case WITHDRAWABLE:
                result[UserInfoTypes.BALANCE_TYPES.WITHDRAWABLE] = Number(balance.balance.amount) || 0;
                break;
            case SPORTS_BONUS:
                result[UserInfoTypes.BALANCE_TYPES.BONUS] = Number(balance.balance.amount) || 0;
                break;
            case SPORTS_TOKEN:
                result[UserInfoTypes.BALANCE_TYPES.FREE_BET] = Number(balance.balance.amount) || 0;
                break;
        }
    });
    updateBalancesInMojFormat(result);
}

let balancesListener = null;
export function setUpdateBalancesListener(val) {
    balancesListener = wrapExternal(val);
}

reduxInstance.actionListener.startListening({
    actionCreator: BalancesActions.updateBalancesForHost,
    effect: () => {
        if (balancesListener) balancesListener(selectBalancesForHost());
    },
});

export function getBalances() {
    return selectBalancesForHost();
}

/**
 * Adapt and store user balances that coming from IMS OpenAPI.
 * Both withdrawable and bonus balances must be specified.
 * @param message32010 {object} - message directly from OpenAPI
 * @param ignoreIMSFreebetBalance {boolean} - if true, freebet balance updates from IMS will be ignored
 */
// To start retrieving balances, client must be subscribed to balance updates
// See doc: https://ims.ptdev.eu/apis/openapi/services/AuthenticationService/operations/StartWindowSession.html
export function handle32010message(message32010, ignoreIMSFreebetBalance = false) {
    // -- Adopt balances message
    if (message32010.ID !== BALANCE_UPDATE_ID) {
        return; // it is not balance update message
    }

    const {balances} = message32010.data;
    const data = {};

    balances.forEach(balanceItem => {
        const {balanceType: imsBalanceType} = balanceItem;
        const balanceType = BALANCE_TYPES_MAP[imsBalanceType];
        if (!balanceType) return;

        if (ignoreIMSFreebetBalance) {
            // Ignore freebet balance updates from IMS (OpenAPI) when freebet polling enabled. In such a case, the freebet balance calculated based on polled freebets.
            // This is because the IMS freebet balance updates were unstable in the past. Once it's fixed, Sportsbook could disable the freebet balance polling on it's side, and rely on IMS.
            if (balanceType === UserInfoTypes.BALANCE_TYPES.FREE_BET) return;
        }

        data[balanceType] = balanceItem.balance.amount;
    });

    if (Object.keys(data).length === 0) {
        return; // Do not override balance if nothing to update
    }
    updateBalancesInMojFormat(data);
}

const BALANCE_TYPES_MAP = {
    /** Withdrawable balance */
    sportsbook_gaming_balance: UserInfoTypes.BALANCE_TYPES.WITHDRAWABLE,
    /** Bonus balance */
    sportsbook_bonus_balance: UserInfoTypes.BALANCE_TYPES.BONUS,
    /** FreeBet balance */
    sportsbook_freebet_balance: UserInfoTypes.BALANCE_TYPES.FREE_BET,
};

const BALANCE_UPDATE_ID = 32010; // NotifyBalanceChangeNotification message ID
